export default "__VITE_ASSET__D2EOif2n__"